module.exports = __webpack_public_path__ + "static/media/Closed.87e530ca.svg";